import axios from 'axios';
import { handleRequest } from './util.api';

const URL_COMPANIES_TOGGLE = `/companies/:companyId/toggle`;
const URL_COMPANIES_ADD = `/companies`;
const URL_COMPANIES_UPDATE = `/companies/:companyId`;
const URL_COMPANIES_UPDATE_ROOT = `/companies/:companyId/root`;
const URL_COMPANIES_DELETE = `/companies/:companyId`;

const service = {
  configure(endpoint, auth, defaultHeaders) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
      headers: defaultHeaders,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  addCompany(data) {
    return this.axios
      .post(URL_COMPANIES_ADD, data, {
        headers: { ...this.defaultHeaders, ...this.auth.getAuthHeader() },
      })
      .then((result) => result.data)
      .catch((err) => {
        let data =
          err.response && err.response.data && err.response.data.code
            ? err.response.data
            : {
                code: 500,
                message: 'error.server_error',
              };
        return Promise.reject(data);
      });
  },

  updateCompany(companyId, data) {
    return this.axios
      .put(URL_COMPANIES_UPDATE.replace(':companyId', companyId), data, {
        headers: { ...this.defaultHeaders, ...this.auth.getAuthHeader() },
      })
      .then((result) => result.data)
      .catch((err) => {
        let data =
          err.response && err.response.data && err.response.data.code
            ? err.response.data
            : {
                code: 500,
                message: 'error.server_error',
              };
        return Promise.reject(data);
      });
  },

  updateCompanyRoot(companyId, data) {
    return this.axios
      .put(URL_COMPANIES_UPDATE_ROOT.replace(':companyId', companyId), data, {
        headers: { ...this.defaultHeaders, ...this.auth.getAuthHeader() },
      })
      .then((result) => result.data)
      .catch((err) => {
        let data =
          err.response && err.response.data && err.response.data.code
            ? err.response.data
            : {
                code: 500,
                message: 'error.server_error',
              };
        return Promise.reject(data);
      });
  },

  toggleCompany(companyId) {
    return this.axios
      .put(
        URL_COMPANIES_TOGGLE.replace(':companyId', companyId),
        {},
        {
          headers: { ...this.defaultHeaders, ...this.auth.getAuthHeader() },
        }
      )
      .then((result) => result.data)
      .catch((err) => {
        let data =
          err.response && err.response.data && err.response.data.code
            ? err.response.data
            : {
                code: 500,
                message: 'error.server_error',
              };
        return Promise.reject(data);
      });
  },

  deleteCompany(companyId) {
    return this.axios
      .delete(URL_COMPANIES_DELETE.replace(':companyId', companyId), {
        headers: { ...this.defaultHeaders, ...this.auth.getAuthHeader() },
      })
      .then((result) => result.data)
      .catch((err) => {
        let data =
          err.response && err.response.data && err.response.data.code
            ? err.response.data
            : {
                code: 500,
                message: 'error.server_error',
              };
        return Promise.reject(data);
      });
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/companies.api.js